import { ApplicationData } from '../../../../types/TymbeApi';
import ResolvedAttendanceRow from './ResolvedAttendanceRow';
import { BadgePill } from '@tymbe/ty-components/indicators';

type ResolvedAttendanceProps = {
  applications: ApplicationData[];
};

const ShiftResolvedAttendance = ({ applications }: ResolvedAttendanceProps) => {
  return (
    <div className="flex flex-col w-full">
      <div className="py-4 bg-white rounded-xl">
        <div className="flex items-center gap-2">
          <span className="text-green-700 text-body-2-xl font-semibold">
            Potvrzená docházka
          </span>
          <BadgePill variant="success">{applications.length}</BadgePill>
        </div>
      </div>
      {applications.length ? (
        <div className="rounded-2xl border border-secondary-transparent-10 bg-green-100 divide-y divide-secondary-transparent-10">
          {applications.map((application) => (
            <ResolvedAttendanceRow key={application.id} application={application} />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default ShiftResolvedAttendance;
